<!--  -->
<template>
    <div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>品牌建设</el-breadcrumb-item>
      </el-breadcrumb>
      
      <div v-for="item in typeList" style="display: flex;flex-direction: column;border-color: #59b6ff;margin-bottom: 20px;background-color: #fff;border: 1px solid transparent;border-radius: 4px;box-shadow: 0 1px 1px rgba(0, 0, 0, .05);margin-top: 10px;">
        <div style="color: #fff;
      background-color: #59b6ff;
      border-color: #59b6ff;    padding: 10px 15px;
      border-bottom: 1px solid transparent;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;">所属栏目：{{item[0].type_dictText}}</div>
        <el-table
          :data="item"
          style="width: 100%">
          <el-table-column
            label="序号"
            type="index"
            width="50">
          </el-table-column>
          <el-table-column
            label="标题名称">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column label="附件">
            <template slot-scope="scope">
              <!-- <a :href="getUrl() + scope.row.files" :download="(scope.row.title + fixImage(scope.row.files).slice(fixImage(scope.row.files).lastIndexOf('.')))" style="color: blue;text-decoration: underline;cursor: pointer;" target="_blank">{{ scope.row.title + fixImage(scope.row.files).slice(fixImage(scope.row.files).lastIndexOf('.')) }}</a> -->
              <!-- <span style="color: blue;text-decoration: underline;cursor: pointer;" @click="downloadExcel(scope.row.files)">{{ fixImage(scope.row.files) }}</span> -->
              <span style="color: blue;text-decoration: underline;cursor: pointer;" @click="downloadExcel(scope.row)">{{ scope.row.title + fixImage(scope.row.files).slice(fixImage(scope.row.files).lastIndexOf('.')) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="服务说明"
            width="240">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.type_dictText }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </template>
  
  <script>
  import { Server,httpurl } from "@/server";
  //引入axios插件
  import axios from "axios";
  export default {
    data () {
      return {
        tableData: [{
            date: '2016-05-02',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1518 弄'
          }, {
            date: '2016-05-04',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1517 弄'
          }, {
            date: '2016-05-01',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1519 弄'
          }, {
            date: '2016-05-03',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1516 弄'
          }],
          typeList:[],
          typeNow:-1
      }
    },
    mounted() {
      this.getLegislation()
    },
    methods: {
      getUrl() {
        return httpurl + '/sys/common/static/';
      },
      getLegislation() {
        Server.getQualityBrandInfo({
          pageSize : -1
        }).then((res) => {
            if (res.code == 200) {
                console.log(res.result.records)
                var data = res.result.records
                var type = []
                data.forEach((item,index) => {
                  if (index == 0) {
                    this.typeNow = item.type
                  }
                  if (item.type == this.typeNow) {
                    type.push(item)
                  } else {
                    this.typeNow = item.type
                    this.typeList.push(type)
                    type = []
                    type.push(item)
                  }
                  if (index == data.length -1) {
                    this.typeList.push(type)
                  }
                });
                // this.total = res.result.total
                // this.contentList = Array(res.result.records).reverse();
                // this.contentList = res.result.records;
            }
            
            // this.contentList.sort((a, b) => {
            //     return a.releaseTime < b.releaseTime ? -1 : 1
            // })
            // console.log(this.contentList)
        });
      },
  
      fixImage (file) {
        var arr = file.split("/"); // 使用逗号分割字符串
        var lastElement = arr.slice(-1)[0]; // 取得最后一个元素
        return lastElement
      },
  
      async downloadExcel (fileName) {
          var fileUrl = this.getUrl()
          var fileLastName = fileName.title + this.fixImage(fileName.files).slice(this.fixImage(fileName.files).lastIndexOf('.'))

          const x = new window.XMLHttpRequest();
          console.log(fileUrl + fileName.files);
          
            x.open('GET', fileUrl + fileName.files, true);
            x.responseType = 'blob';
            x.onload = () => {
                const url = window.URL.createObjectURL(x.response);
                const a = document.createElement('a');
                a.href = url;
                a.download = fileLastName;
                a.click();
            };
            x.send();
      }
    }
  }
  </script>
  
  <style  scoped lang="less">
    ::v-deep .cell {
      text-align: center;
    }
  </style>
  